import * as contentful from 'contentful';

export const client = contentful.createClient({
	space: 'uya48b6er3ia',
	accessToken: 'BjPkGQojQt4TPetw6qz8-O-OWLmWqZLjS8QHgAg2iQM'
});
